import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SectionHeader from '../Basic/SectionHeader';
import EmailBox from '../Enhanced/EmailBox';
import TextBox from '../Basic/TextBox';
import $ from 'jquery';
import util from '../../lib/util';

class DoubleEmail extends React.Component {
  componentDidMount() {
    $(`#${this.props.name}`).bind("cut copy paste", function (e) { e.preventDefault(); });
    $(`#${this.props.name}_2`).bind("cut copy paste", function (e) { e.preventDefault(); });
  }
  render() {
    const p = this.props;
    const s = p.value1 && p.value2 && (p.value1 != p.value2);
    const t1 = p.title1 ? p.title1 : "Email";
    const t2 = p.title2 ? p.title2 : "Re-enter email";
    return (
      <div>
        <SectionHeader title={p.title} />
        <EmailBox name={p.name} title={t1} customClass={p.customClass} required={p.required} disabled={p.disabled}  errorMsg="Email is required" maxLength={241} />
        <TextBox name={`${p.name}_2`} title={t2} customClass={p.customClass} required={p.required} errorMsg="Email is required" maxLength={241} />
        {s ? <label className="control-label has-error validationMessage">Emails do not match</label> : null}
      </div>
    );
  }
}
DoubleEmail.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
};
const mapStateToProps = (state, props) => {
  return {
    value1: state.form && state.form[props.name],
    value2: state.form && state.form[props.name + '_2']
  };
};
export default connect(mapStateToProps)(DoubleEmail);
export function DoubleEmailValidation(name) {
  return [
    [name, p => p[name], "Email"],
    [name, p => util.isEmailValid(p[name]), "#Email is invalid"],
    [name + "_2", p => p[name + "_2"], "#Email is required"],
    [name + "_2", p => (p[name] == p[name + "_2"]), "#Emails do not match"]
  ];
}